const initDistributorFinder = () => {
  const countrySelect = document.getElementById('DistributorCountry');
  const regionField = document.getElementById('DistributorRegionField');
  const regionLabel = regionField?.querySelector('label');
  const regionSelect = document.getElementById('DistributorRegion');
  const resultsContainer = document.getElementById('DistributorResults');

  const regionDataElement = document.getElementById('DistributorRegionData');
  const distributorDataElement = document.getElementById('DistributorData');

  if (
    !countrySelect ||
    !regionField ||
    !regionLabel ||
    !regionSelect ||
    !resultsContainer ||
    !regionDataElement ||
    !distributorDataElement
  ) {
    return;
  }

  if (countrySelect.dataset.initialized === 'true') {
    return;
  }

  countrySelect.dataset.initialized = 'true';

  let regions = [];
  let distributors = [];

  try {
    regions = JSON.parse(regionDataElement.textContent);
    distributors = JSON.parse(distributorDataElement.textContent);
  } catch (error) {
    console.error('Distributor Finder data could not be parsed.', error);
    countrySelect.dataset.initialized = 'false';
    return;
  }

  const getSelectedCountryOption = () => {
    return countrySelect.options[countrySelect.selectedIndex];
  };

  const getSelectedCountryHandle = () => {
    return getSelectedCountryOption()?.value || '';
  };

  const getSelectedRegionHandle = () => {
    return regionSelect.value || '';
  };

  const selectedCountryHasSubdivision = () => {
    return getSelectedCountryOption()?.dataset.hasSubdivision === 'true';
  };

  const getSubdivisionLabel = () => {
    return (
      getSelectedCountryOption()?.dataset.subdivisionLabel || 'Region'
    );
  };

  const clearResults = () => {
    resultsContainer.innerHTML = '';
  };

  const renderNoResults = () => {
    resultsContainer.innerHTML = '<p>No distributors found.</p>';
  };

  const renderContactItem = (label, value, href, external = false) => {
    if (!value) {
      return '';
    }

    return `
      <div class="ev-distributor-card__contact-item">
        <span class="ev-distributor-card__contact-label ev-small-caps">
          ${label}
        </span>

        <a
          class="ev-distributor-card__contact-value ev-text ev-dark-mist"
          href="${href}"
          ${external ? 'target="_blank" rel="noopener noreferrer"' : ''}
        >
          ${value}
        </a>
      </div>
    `;
  };

  const renderResultsHeader = (locationName, count) => {
    return `
      <header class="ev-distributor-results__header">
        <h2 class="ev-distributor-results__heading ev-heading">
          ${locationName}
        </h2>

        <!--
        <span class="ev-distributor-results__count ev-small-caps">
          ${count} ${count === 1 ? 'Distributor' : 'Distributors'}
        </span>
        -->
      </header>
    `;
  };

  const renderDistributors = (matchingDistributors) => {
    clearResults();

    if (!matchingDistributors.length) {
      const fallbackDistributor = distributors.find(
        (distributor) => distributor.fallbackDistributor
      );

      if (fallbackDistributor) {
        matchingDistributors = [fallbackDistributor];
      } else {
        renderNoResults();
        return;
      }
    }

    const selectedCountryOption =
      countrySelect.options[countrySelect.selectedIndex];

    const selectedRegionOption =
      regionSelect.options[regionSelect.selectedIndex];

    const locationName =
      selectedCountryHasSubdivision() && getSelectedRegionHandle()
        ? selectedRegionOption.textContent.trim()
        : selectedCountryOption.textContent.trim();

    const cards = matchingDistributors
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((distributor) => {
        const phoneHref = distributor.phone
          ? `tel:${distributor.phone.replace(/[^\d+]/g, '')}`
          : '';

        const emailHref = distributor.email
          ? `mailto:${distributor.email}`
          : '';

        const contactItems = [
          renderContactItem(
            'Telephone',
            distributor.phone,
            phoneHref
          ),
          renderContactItem(
            'Email',
            distributor.email,
            emailHref
          ),
          renderContactItem(
            'Website',
            distributor.website,
            distributor.website,
            true
          )
        ].join('');

        return `
          <article class="ev-distributor-card">
            <div class="ev-distributor-card__primary">
              <h3 class="ev-distributor-card__name ev-heading ev-mt0">
                ${distributor.name}
              </h3>

              ${
                distributor.address
                  ? `
                    <address class="ev-distributor-card__address ev-text">
                      ${distributor.address.replace(/\n/g, '<br>')}
                    </address>
                  `
                  : ''
              }

              ${
                distributor.description
                  ? `
                    <div class="ev-distributor-card__description ev-text">
                      <p>${distributor.description}</p>
                    </div>
                  `
                  : ''
              }
            </div>

            ${
              contactItems
                ? `
                  <div class="ev-distributor-card__contacts">
                    ${contactItems}
                  </div>
                `
                : ''
            }
          </article>
        `;
      })
      .join('');

    resultsContainer.innerHTML = `
      <div class="ev-distributor-results">
        ${renderResultsHeader(locationName, matchingDistributors.length)}

        <div class="ev-distributor-results__list">
          ${cards}
        </div>
      </div>
    `;
  };

  const populateRegions = () => {
    const countryHandle = getSelectedCountryHandle();
    const hasSubdivision = selectedCountryHasSubdivision();
    const subdivisionLabel = getSubdivisionLabel();

    regionSelect.innerHTML = '';
    regionSelect.disabled = true;
    regionField.classList.add('is-disabled');

    if (!countryHandle) {
      regionLabel.textContent = 'Region';

      regionSelect.innerHTML = `
        <option value="">
          Select country first
        </option>
      `;

      return;
    }

    if (!hasSubdivision) {
      regionLabel.textContent = 'Region';

      regionSelect.innerHTML = `
        <option value="">
          Not required
        </option>
      `;

      return;
    }

    regionLabel.textContent = subdivisionLabel;

    regionSelect.innerHTML = `
      <option value="">
        Select ${subdivisionLabel.toLowerCase()}
      </option>
    `;

    const matchingRegions = regions
      .filter((region) => region.countryHandle === countryHandle)
      .sort((a, b) => a.name.localeCompare(b.name));

    matchingRegions.forEach((region) => {
      const option = document.createElement('option');

      option.value = region.handle;
      option.textContent = region.name;

      regionSelect.appendChild(option);
    });

    regionSelect.disabled = false;
    regionField.classList.remove('is-disabled');
  };

  const updateResults = () => {
    const countryHandle = getSelectedCountryHandle();
    const regionHandle = getSelectedRegionHandle();
    const hasSubdivision = selectedCountryHasSubdivision();

    clearResults();

    if (!countryHandle) {
      return;
    }

    const hasCountryDistributors = distributors.some((distributor) => {
      return (
        !distributor.fallbackDistributor &&
        distributor.countryHandle === countryHandle
      );
    });

    if (hasSubdivision && !regionHandle) {
      if (!hasCountryDistributors) {
        renderDistributors([]);
      }

      return;
    }

    const matchingDistributors = distributors.filter((distributor) => {
      if (distributor.fallbackDistributor) {
        return false;
      }

      const matchesCountry =
        distributor.countryHandle === countryHandle;

      const matchesRegion =
        !hasSubdivision ||
        distributor.regionHandles.includes(regionHandle);

      return matchesCountry && matchesRegion;
    });

    renderDistributors(matchingDistributors);
  };

  countrySelect.addEventListener('change', () => {
    populateRegions();
    updateResults();
  });

  regionSelect.addEventListener('change', () => {
    updateResults();
  });

  // Restore the UI if a country/region is already selected
  populateRegions();
  updateResults();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDistributorFinder);
} else {
  initDistributorFinder();
}

document.addEventListener('shopify:section:load', initDistributorFinder);